import { atom } from "jotai";

export const toastState = atom({
  key: "toastState",
  default: {
    severity: "",
    summary: "",
    detail: "",
    life: 3000,
    visible: false, // Para controlar cuándo mostrar la notificación
  },
});
